import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { getSimParam } from "./utils.js";

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse"

import CardTitle from "./CardTitle.js";
import CourseCardStep from "./CourseCardStep.js";
import ButtonGrid from "./ButtonGrid.js";
import MyButton from "./MyButton.js";

export default function CourseCard (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const personal = getSimParam(gData, "personalCourses");

    function selectCourse () { gDispatch({ type: "upload", table: "course", id: courseID, data: { selected: 1 } }); }
    function unselectCourse () { gDispatch({ type: "upload", table: "course", id: courseID, data: { selected: 0 } }); }

    function setDone () { gDispatch({ type: "upload", table: "course", id: courseID, data: { state: "done" } }); setRead(false); }

    const courseID = props.courseID;
    const course = gData.course[courseID];
    const courseTitle = course.title;
    let courseContent = [];
    try { courseContent = JSON.parse(course.content); } catch (e) { courseContent = []; }

    // TODO : optimize with more global computation of that list ?
    let num = 1;
    let first = true;
    const courseData = Object
	.entries(gData.course)
	.filter(([id, course]) => course.simID === gData.simID && course.selected === 1)
    	.sort(([id1, course1], [id2, course2]) => course1.rank - course2.rank)
	.map(([id, course]) => {
	    let state = course.state;
	    if (course.state === "todo" && first) { state = "current"; first = false; }
	    return { id: course.courseID, num: num++, state: state };
	})
	.filter((course) => course.id === courseID);

    const courseNum = courseData.length === 0 ? null : courseData[0].num;
    const courseState = courseData.length === 0 ? null : courseData[0].state;
    const courseSubtitle = "Cours" + (courseNum === null ? "" : " " + courseNum);

    const selected = course.selected === 1;

    const [read, setRead] = useState(courseState === "current");
    function handleRead () { setRead(!read); }

    const stepList = courseContent.map((step, index) => (<CourseCardStep key={index} step={step}/>));
    
    let light = false;
    let courseCardClassNames = "";
    let courseCardHeaderClassNames = "";
    switch (courseState)
    {
	case "done" :
	courseCardClassNames = "border-secondary border-2";
	courseCardHeaderClassNames = "bg-secondary";
	light = true;
	break;

	case "current" :
	courseCardClassNames = "border-primary border-2";
	courseCardHeaderClassNames = "bg-primary";
	light = true;
	break;

	default : break;
    }


    return (
	<>
	    <Card className={"shadow-sm " + courseCardClassNames} style={{ width: 600 }}>
		<Card.Header className={courseCardHeaderClassNames}>
		    <CardTitle title={courseTitle} subtitle={courseSubtitle} light={light}>
			<MyButton icon={read ? "readLess" : "readMore"} variant={light ? "outline-light" : "outline-secondary"} onClick={handleRead}/>
		    </CardTitle>
		</Card.Header>
		<Collapse in={read}>
		    <div>
			<Card.Body>
			    <div className="d-flex flex-column gap-3">{stepList}</div>
			</Card.Body>
			{(personal || courseState === "current") && (
			    <Card.Footer className="d-flex flex-column gap-2">
				<ButtonGrid>
				    <ButtonGrid.Left>
					{(personal && selected) && (<Button variant="outline-secondary" size="md" onClick={unselectCourse}>Mettre en réserve</Button>)}
					{(personal && ! selected) && (<Button variant="outline-secondary" size="md" onClick={selectCourse}>Ajouter à la liste</Button>)}
				    </ButtonGrid.Left>
				    <ButtonGrid.Right>
					{courseState === "current" && (<Button variant="primary" size="md" onClick={setDone}>Cours terminé</Button>)}
				    </ButtonGrid.Right>
				</ButtonGrid>
			    </Card.Footer>
			)}
		    </div>
		</Collapse>
	    </Card>
	</>
    );
}
